// src/Utils/apiHelper.ts
import { AxiosResponse } from 'axios';

import axiosInstance from './interceptors';

export type ApiResponse<T> = {
  data?: T;
  success: boolean;
  error?: string;
};

/**
 * Función genérica para llamadas a la API con try/catch y logging centralizado.
 */
export const apiRequest = async <T>(
  method: 'get' | 'post' | 'put' | 'delete',
  url: string,
  payload?: any,
  config: Record<string, any> = {},
): Promise<ApiResponse<T>> => {
  try {
    let response: AxiosResponse<T>;

    switch (method) {
      case 'get':
        response = await axiosInstance.get(url, { params: payload, ...config });
        break;
      case 'post':
        response = await axiosInstance.post(url, payload, config);
        break;
      case 'put':
        response = await axiosInstance.put(url, payload, config);
        break;
      case 'delete':
        response = await axiosInstance.delete(url, { data: payload, ...config });
        break;
      default:
        throw new Error(`Método HTTP no soportado: ${method}`);
    }

    return { data: response.data, success: true };
  } catch (error: any) {
    console.error('API Error:', error);

    // adjuntamos info custom
    error.apiResponse = {
      success: false,
      error: error?.response?.data?.message || error?.message || 'Unexpected API error',
      status: error?.response?.status,
      data: error?.response?.data,
    };

    throw error; // el caller decide qué hacer
  }
};
